export default {
  title: 'Ressources',
  subtitle: 'Gérez et parcourez vos ressources',
  createResource: 'Créer une Ressource',
  createSubtitle: 'Ajouter une nouvelle ressource à votre inventaire',
  editResource: 'Modifier la Ressource',
  editTitle: 'Modifier la Ressource',
  editSubtitle: 'Mettre à jour les informations de la ressource',
  createSuccess: 'Ressource créée avec succès',
  createError: 'Échec de la création de la ressource',
  updateSuccess: 'Ressource mise à jour avec succès',
  updateError: 'Échec de la mise à jour de la ressource',
  loadError: 'Échec du chargement de la ressource',
  notFound: 'Ressource introuvable',
  images: 'Images',
  filters: {
    category: 'Catégorie',
    availability: 'Disponibilité',
    allCategories: 'Toutes les Catégories',
    allResources: 'Toutes les Ressources',
    availableOnly: 'Disponibles Seulement',
    unavailableOnly: 'Indisponibles Seulement'
  },
  loading: 'Chargement des ressources...',
  fetchCategoriesError: 'Échec du chargement des catégories',
  noResources: 'Aucune ressource trouvée',
  resourceClicked: 'Ressource cliquée',
  resourceForm: {
    name: 'Nom',
    nameRequired: 'Le nom est requis',
    nameMinLength: 'Le nom ne peut pas être vide',
    namePlaceholder: 'Entrez le nom de la ressource',
    description: 'Description',
    descriptionPlaceholder: 'Entrez la description de la ressource (optionnel)',
    category: 'Catégorie',
    categoryRequired: 'La catégorie est requise',
    selectCategory: 'Sélectionnez une catégorie',
    location: 'Lieu',
    locationRequired: 'Le lieu est requis pour les ressources partagées',
    selectLocation: 'Sélectionnez un lieu',
    resourceScope: 'Appartenance',
    personal: 'Personnelle',
    shared: 'Partagée',
    scopeTooltip: 'Les ressources personnelles vous appartiennent et peuvent être empruntées par tous',
    personalResourceHelp: 'Cette ressource vous appartiendra et sera visible et empruntable par tous les utilisateurs.',
    personalOnlyHelp: 'Vous ne pouvez créer que des ressources personnelles. Contactez un administrateur pour les permissions de ressources partagées.',
    personalLocationError: 'Les ressources personnelles ne peuvent pas avoir de lieu',
    resourceType: 'Type de ressource',
    consumable: 'Consommable',
    unique: 'Unique',
    consumableTooltip: 'Définit si la ressource est consommable ou unique',
    quantity: 'Quantité',
    availability: 'Disponibilité',
    available: 'Disponible',
    unavailable: 'Indisponible',
    availabilityTooltip: 'Définit si la ressource est disponible pour utilisation',
    notes: 'Notes',
    notesPlaceholder: 'Entrez des notes supplémentaires (optionnel)',
    saveError: 'Échec de la sauvegarde de la ressource',
    fetchOptionsError: 'Échec du chargement des options du formulaire'
  },
  admin: {
    createTitle: 'Créer une Ressource',
    editTitle: 'Modifier la Ressource',
    deleteTitle: 'Supprimer la Ressource',
    createSuccess: 'Ressource créée avec succès',
    updateSuccess: 'Ressource mise à jour avec succès',
    deleteSuccess: 'Ressource supprimée avec succès',
    createError: 'Échec de la création de la ressource',
    updateError: 'Échec de la mise à jour de la ressource',
    deleteError: 'Échec de la suppression de la ressource',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cette ressource ? Cette action est irréversible.'
  },

  // Resource-specific actions
  resourceRefill: {
    refillResource: 'Refaire le Stock',
    subtitle: 'Refaire le stock de {{resourceName}}',
    loading: 'Chargement...',
    notFound: 'Ressource non trouvée',
    fetchError: 'Erreur lors de la récupération de la ressource',
    refillError: 'Erreur lors du refill de la ressource'
  },

  resourceConsume: {
    consumeResource: 'Consommer la Ressource',
    subtitle: 'Consommer {{resourceName}}',
    loading: 'Chargement...',
    notFound: 'Ressource non trouvée',
    fetchError: 'Erreur lors de la récupération de la ressource',
    consumeError: 'Erreur lors de la consommation de la ressource'
  },

  resourceBorrow: {
    borrowResource: 'Emprunter la Ressource',
    subtitle: 'Emprunter {{resourceName}}',
    loading: 'Chargement...',
    notFound: 'Ressource non trouvée',
    fetchError: 'Erreur lors de la récupération de la ressource',
    borrowError: 'Erreur lors de l\'emprunt de la ressource'
  },

  resourceReserve: {
    reserveResource: 'Réserver la Ressource',
    subtitle: 'Réserver {{resourceName}}',
    loading: 'Chargement...',
    notFound: 'Ressource non trouvée',
    fetchError: 'Erreur lors de la récupération de la ressource',
    reserveError: 'Erreur lors de la réservation de la ressource'
  }
};
